import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: ['./content-card.component.scss'],
  animations: [
    trigger('pageAnimations', [
      transition('* => final', [
        query('.card-main-content', style({ maxHeight: '100px' })),
        query('.card-projected-content', style({ opacity: 0 })),

        query('.card-main-content', stagger(0, [animate(200, style({ maxHeight: '2000px' }))])),
        query('.card-projected-content', stagger(0, [animate('800ms', style({ opacity: 1 }))]))
      ])
    ])
  ]
})
export class ContentCardComponent implements OnInit, OnDestroy {
  @Input() loading: boolean;
  @Input() isShowTitleBorder = true;
  @Input() isShowCardBorder = false;
  @Input() isShowShadow = false;
  @Input() isShowBackButton = true;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() minHeigth = '100';
  @Input() hasHeader = true;
  @Input() isDetailPage = false;
  detailTitle = '';
  isCollapsed = false;
  subscription: Subscription;
  @Input() set itemTitle(val: string) {
    this.detailTitle = val;
  };
  @Input() titleImageUrl = '';
  @Input() titleIcon = '';
  @Input() isFixedHeader = true;

  routeData: any;


  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.subscription = new Subscription();
    this.loading = false;
  }

  ngOnInit() {
    this.routeData = this.activatedRoute.snapshot.data;
    // this.subscription.add(this.appShellService.onSideNavToggleEvent.pipe(filter(val => !!val)).subscribe(event => {
    //   console.log(event);
    //   this.isCollapsed = event.state !== 'expand';
    //   console.log(this.isCollapsed);
    // }));

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  navigateBack() {
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }
}
